export default __webpack_public_path__ + "static/media/154_Hamilton_Map_1BR.4886e51a.svg";